"use client";

import { defaultLocale, type Locale } from "@/lib/i18n";
import AgentUseCasePage from "./AgentUseCasePage";
import { productEnquiry } from "@/content/agent-use-cases/product-enquiry";

export default function ProductEnquiryUseCase({
  locale = defaultLocale,
}: {
  locale?: Locale;
}) {
  return <AgentUseCasePage useCase={productEnquiry} locale={locale} />;
}
